import { MovieStreamTileFragment } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { TileMeta } from '../../feature-player/types/tiles';

export const transformTile = ({
    spriteDuration,
    tileDuration,
    uriTemplate,
    tilePixelResolution,
    spriteMatrixSize,
    spritePixelResolution,
}: MovieStreamTileFragment): TileMeta => ({
    spriteDuration,
    tileDuration,
    uriTemplate,
    resolution: spritePixelResolution,
    tileSize: tilePixelResolution,
    tiles: spriteMatrixSize,
});
